export default "__VITE_ASSET__Bdz_ZQBz__"